export default "/images/9bc985ca09476ff1d82beec21c5977ed.avif";